import { render, staticRenderFns } from "./TheSourceSwitch.vue?vue&type=template&id=291ede06&scoped=true&"
import script from "./TheSourceSwitch.vue?vue&type=script&lang=js&"
export * from "./TheSourceSwitch.vue?vue&type=script&lang=js&"
import style0 from "./TheSourceSwitch.vue?vue&type=style&index=0&id=291ede06&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "291ede06",
  null
  
)

export default component.exports